import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Box, Button, CircularProgress, Container, Modal, Snackbar, Stack, Typography } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Padding, PaletaColor } from "../../../styles/StylesConstantes";
import { Add, Delete, Edit } from "@mui/icons-material";
import { getLocalesAdheridos, postDeleteLocalBeneficio } from "../../../api/ApiService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BeneficioDetalleHeader from "./components/BeneficioDetalleHeader";
import BeneficioLocalesDetalleTableComponent from "./components/BeneficioLocalesDetalleTableComponent";
import EliminarLocalAdheridoModal from "./components/EliminarLocalAdheridoModal";



function BeneficiosLocalesAdheridosPage() {
  const [loading, setLoading] = useState(false);
  const [dataBeneficios, setDataBeneficios] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [dataDelete, setDataDelete] = useState(null);
  const [loadingEleiminar, setLoadingEliminar] = useState(false);

  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [loadingCargar, setLoadingCargar] = useState(false);
  const [metaPaginacion, setMetaPaginacion] = useState({
    current_page: 1,
    per_page: 10,
    total: 0,
    last_page: 1
  });
  const [perPage, setPerPage] = useState(10);





  const stateToken = useSelector(state => state.reducerGlobal.token);

  let history = useNavigate();

  const location = useLocation();
  const { state } = location;

  let { id } = useParams();






  useEffect(() => {
    if (stateToken) {
      handleApiFiltrarBeneficios();
    }
  }, [id, stateToken]);









  const columns = [
    // { field: 'id',
    //    headerName: 'ID', 
    //    width: 90 
    //   },
    {
      field: 'titulo',
      headerName: 'Local',
      flex: 1,
      editable: false,
      renderCell: (params) => params?.row?.local?.nombre_fantasia ? params?.row?.local?.nombre_fantasia : '' || '',
    },
    {
      field: 'imagen',
      headerName: 'Logo',
      flex: 1,
      editable: false,
      renderCell: (params) => (
        params?.row?.local?.logo !== '' &&
        <img
          src={params?.row?.local?.logo || ''}
          alt="icon"
          style={{ width: 150, height: undefined, aspectRatio: 1 }}
        />
      ),
    },
    {
      field: 'observacion',
      headerName: 'Observación',
      flex: 1,
      editable: false,
      // renderCell: (params) => params?.row?.locales?.length > 0 ? params?.row?.locales?.map((item) => item?.nombre_fantasia).join(', ') : '' || '', // Accede al nombre del usuario
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Acciones',
      flex: 1,
      cellClassName: 'actions',
      getActions: ({ id, row }) => {
        return [
          <GridActionsCellItem
            icon={<Edit />}
            label="Edit"
            className="textPrimary"
            onClick={() => handleEditClick(row)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<Delete />}
            label="Delete"
            onClick={() => handleDeleteClick(row)}
            color="inherit"
          />,
        ];
      },
    },
  ];



  //=========================================================funcion para eliminar el local adherido
  const handleEliminarLocal = () => {
    let body = {
      local_id: dataDelete.local_id,
      beneficio_id: dataDelete.beneficio_id,
    };
    console.log('body', body);
    setLoadingEliminar(true);
    handleUpdateBeneficioApi(body);
  }



  //=========================================================api de actualizar beneficio
  const handleUpdateBeneficioApi = (body) => {

    postDeleteLocalBeneficio(body, stateToken?.access_token)
      .then((response) => {
        console.log("response-postDeleteLocalBeneficio", response);
        setLoadingEliminar(false);

        setDataBeneficios(dataBeneficios.filter((row) => row.id !== dataDelete.id));

        setTimeout(() => {
          handleCloseModal();

          setOpen(true);
          setSeverity('success');
          setMensaje('Eliminado correctamente');

        }, 1000);


      })
      .catch((error) => {
        console.log("error-postDeleteLocalBeneficio", error);
        setLoadingEliminar(false);


        setOpen(true);
        setSeverity('error');
        setMensaje('Error al guardar');

        setTimeout(() => {
          setOpen(false);
        }, 2000);
      });
  };




  //=================================================================================================funcion para editar, obtener el id
  const handleEditClick = (row) => {
    console.log('Edit', row);
    // history(`/app/admin/beneficio-detalle/${id}`,
    history(`/app/admin/beneficios-local/editar/beneficio/${row?.beneficio_id}/local/${row.local_id}`,
      {
        state: {
          data: row,
          beneficio: state?.data?.nombre,
          status: "editar",
        }
      }
    );
  };

  //=================================================================================================funcion para eliminar, obtener el id
  const handleDeleteClick = (row) => {
    console.log('Delete', row);
    // setDataBeneficios(dataBeneficios.filter((row) => row.id !== id));
    handleOpenModal();
    setDataDelete(row);
  }

  //=================================================================================================funcion para ir a la pantalla de agregar
  const handleAddLocal = () => {
    history('/app/admin/beneficios-local/agregar/' + id,
      {
        state: {
          data: null,
          beneficio: state?.data?.nombre,
          status: "agregar",
        }
      }
    );
  };

  //=================================================================================================cerrar modal de alerta
  const handleClose = () => {
    setOpen(false);
  };


  //=================================================================================================funcion para abrir el modal
  const handleOpenModal = () => {
    setOpenModal(true);
  }

  //=================================================================================================funcion para cerrar el modal
  const handleCloseModal = () => {
    setOpenModal(false);
    setDataDelete(null);
  };









  //============================================================ funcion para filtrar por estado y nombre
  const handleApiFiltrarBeneficios = (page = 1) => {

    // let body = {
    //   page: page,
    //   per_page: perPage,
    //   estado: statusFilter,
    //   titulo: searchFilter
    // };
    // console.log("body-handleApiFiltrarLocales", body);


    setLoadingCargar(true);

    getLocalesAdheridos(id, stateToken?.access_token)
      .then(response => {
        // console.log("response==>getLocalesAdheridos", response);

        setLoadingCargar(false);

        // Filtrar solo locales activos (excluir eliminados)
        let localesActivos = [];
        if (response.data.length > 0) {
          localesActivos = response.data.filter(item => {
            const local = item?.local;
            if (!local) return false;
            // Excluir si tiene deleted_at o estado "eliminados"
            return !local?.deleted_at && local?.estado !== "eliminados";
          });
          
          setDataBeneficios(localesActivos);
        } else {
          setDataBeneficios([]);
        }

        setLoading(true);




        setMetaPaginacion({
          current_page: response?.current_page,
          per_page: response?.per_page,
          total: localesActivos?.length || 0,
          last_page: response?.last_page
        });


      })
      .catch(error => {
        console.log("error==>getLocalesAdheridos", error);
        setDataBeneficios([]);
        setLoading(true);
        setLoadingCargar(false);
      })
  };




  const handlePerPageChange = (newPerPage) => {
    setPerPage(newPerPage);
  };


  return (
    <HeaderCustom>
      <div className="min-h-screen bg-gray-100 p-6">
        {loading ? (
          <div className="max-w-7xl mx-auto">
            <BeneficioDetalleHeader
              title={`Locales Adheridos a ${state?.data?.nombre || ''}`}
              subtitle="Administra y supervisa los eventos de la plataforma."
              handleAdd={handleAddLocal}
            />




            <div>
              <BeneficioLocalesDetalleTableComponent
                data={dataBeneficios}
                metaPaginacion={metaPaginacion}
                onPageChange={handleApiFiltrarBeneficios}
                perPage={perPage}
                onPerPageChange={handlePerPageChange}
                handleEditarItem={handleEditClick}
                handleOpenModalDelete={handleDeleteClick}
              />
            </div>


            {/* <DataGrid
              rows={dataBeneficios}
              columns={columns}
              rowHeight={100}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 5,
                  },
                },
              }}
              pageSizeOptions={[5, 10, 20]}
              disableRowSelectionOnClick
              localeText={{
                noRowsLabel: 'No hay datos',

              }}
            /> */}




            {/*=============== Eliminar Evento Modal ===================*/}
            <EliminarLocalAdheridoModal
              isOpen={openModal}
              onClose={handleCloseModal}
              onSubmit={handleEliminarLocal}
              loadingDeleteEvento={loadingEleiminar}
            />
            {/* 
            <Modal
              keepMounted
              open={openModal}
              onClose={handleCloseModal}
              aria-labelledby="keep-mounted-modal-title"
              aria-describedby="keep-mounted-modal-description"
            >
              <Box sx={style}>
                <div style={{
                  backgroundColor: PaletaColor.BLANCO,
                  borderRadius: Padding.P3,
                  padding: Padding.P3,
                }}>

                  <Typography variant="h5" align="center" style={{ color: PaletaColor.NEGRO }}>
                    ¿Estas seguro de eliminar?
                  </Typography>

                  <Typography variant="h6" align="center" style={{ color: PaletaColor.COLOR_BACKGROUND_GRIS }}>
                    {dataDelete?.local?.nombre_fantasia}
                  </Typography>


                  <Stack direction="row" justifyContent={"center"} spacing={5} style={{ marginTop: Padding.P3 }}>
                    <Button variant="contained" disabled={loadingEleiminar} onClick={handleEliminarLocal}>
                      {loadingEleiminar ? (
                        <CircularProgress color="inherit" size={24} />
                      ) : (
                        "Eliminar"
                      )}
                    </Button>

                    <Button variant="outlined" onClick={handleCloseModal}>
                      Cancelar
                    </Button>
                  </Stack>
                </div>
              </Box>
            </Modal> */}
          </div>
        ) : (
          <Container sx={{}} style={{}}>
            <SkeletonLoading />
          </Container>
        )}
      </div>

      <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
          {mensaje}
        </Alert>
      </Snackbar>
    </HeaderCustom>
  );
}
export default BeneficiosLocalesAdheridosPage;


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
};
